import { UILogic } from "@aptus/frontend-core";
import { useRoutes } from "domains";
import { MainGrape } from "hooks/mainGrapes/models/mainGrape";
import { SaveMainGrapeInput } from "hooks/mainGrapes/models/mainGrapeInput";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { UseFormTypes } from "../useFormTypes";

interface Props {
	initialValues?: MainGrape;
	submit: (values: SaveMainGrapeInput) => void;
	remove: (id: string) => void;
}

interface Result extends UseFormTypes<MainGrape> {
	handleDelete: (id: string) => void;
}

export const useMainGrapeForm: UILogic<Props, Result> = ({ initialValues, submit, remove }) => {
	const { currentQueryString: { selected, create }, updateQueryString } = useRoutes();

	const defaultValues = {
		...initialValues,
		id: selected,
	};

	const { register, handleSubmit, control, reset, formState: { errors } } = useForm<MainGrape>({ defaultValues });

	useEffect(() => {
		reset(defaultValues);
	}, [create, initialValues]);

	const handleFormSubmit = (values: MainGrape): void => {
		submit(values);
	};

	const handleDelete = (id: string) => {
		remove(id);
		updateQueryString({ selected: null, create: true });
	};

	return {
		register,
		control,
		handleFormSubmit: handleSubmit(handleFormSubmit),
		handleDelete,
		errors,
	};
};
